const getDefaultState = () => ({
  isRequesting: false,
  registrationEmail: null,
  regEmailBillingEnabled: false,
  accountingEmail: null,
  accountingEmailEnabled: false,
});

const state = getDefaultState();

export { getDefaultState };

export default state;
